import React, { FC, useState } from 'react';

import { Box, Snackbar, Typography } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { useTranslation } from 'react-i18next';

import { CustomButton } from '../../../../components/UI/CustomButton';
import useStyles from '../AccountDetailsView/styles';

interface ResetPasswordFormProps {
  email?: string | null;
  passwordBasedAuth: boolean;
  authAppId?: string;
}

const ResetPasswordView: FC<ResetPasswordFormProps> = ({ email, passwordBasedAuth, authAppId }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const hideAlert = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const handleClickResetButton = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://${process.env.REACT_APP_AUTH0_DOMAIN}/dbconnections/change_password`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            client_id: authAppId,
            email: email,
            connection: process.env.REACT_APP_AUTH0_CONNECTION,
          }),
        },
      );

      if (response.status === 200) {
        setOpenAlert(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box className={classes.container}>
        <Box className={classes.info}>
          <Box className={classes.infoCell}>
            <Typography className={classes.infoLabel}>{t('page.account.email')}</Typography>
            <span>{email}</span>
          </Box>
          <Box className={classes.infoCellPlaceholder} />
          {passwordBasedAuth && (
            <>
              <Box className={classes.infoCell}>
                <Typography className={classes.infoLabel}>{t('page.account.password')}</Typography>
                <span>******************</span>
              </Box>
              <Box className={classes.infoCell}>
                <CustomButton
                  color="secondary"
                  btnClass={classes.btn}
                  onClick={() => handleClickResetButton()}
                  disabled={loading}
                >
                  {t('button.resetPassword')}
                </CustomButton>
              </Box>
            </>
          )}
        </Box>
      </Box>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={hideAlert}>
        <MuiAlert elevation={6} variant="filled" onClose={hideAlert} severity="success">
          {t('alert.resetLinkSend')}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default ResetPasswordView;
